import { render, staticRenderFns } from "./Arquivos.vue?vue&type=template&id=77031da9"
import script from "./Arquivos.vue?vue&type=script&lang=js"
export * from "./Arquivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports